import axios from "axios";

import { PaymentSessionToken } from "redmond";
import { purchaseApi, PaymentOpaqueValue } from "@b2bportal/purchase-api";

export const schedulePaymentV1 = ({
  token,
  payments,
  corporateOutOfPolicyReason,
  corporateTripDescription,
  channel,
}: {
  token: PaymentSessionToken;
  payments: Array<PaymentOpaqueValue>;
  corporateOutOfPolicyReason?: string;
  corporateTripDescription?: string;
  channel: "TravelApp" | "Mobile" | "Web";
}): Promise<String> =>
  new Promise((resolve, reject) => {
    try {
      const res = purchaseApi(axios).apiV1PurchaseFulfillSchedulePost({
        quoteToken: {
          value: token.value,
        },
        payments: payments,
        corporateOutOfPolicyReason: corporateOutOfPolicyReason,
        corporateTripDescription: corporateTripDescription,
        channel,
      });

      res.then((body) => resolve(body.data.value)).catch((e) => reject(e));
    } catch (e) {
      reject(e);
    }
  });
